import React, { useEffect, useState } from "react";

const Steps1 = ({ count, setCount, detailsSet, details, initialData, completeCurrentStep }) => {
  // 1
  const [formData, setFormData] = useState();

  const initialErrorData = {
    firstname: "",
    lastname: "",
    dob: "",
    gender: "",
    bloodGroup: "",
    maritalStatus: "",
  };
  //  3rd step
  const [errors, setErrors] = useState(initialErrorData);

  //  4 step
  useEffect(() => {
    setFormData(details);
  }, [details]);

  // Handle input changes
  const handleInputChange = (e) => {

    const { name, value = "" } = e.target;
    if (!!name) {
      if (name === "disabilityCheck") {
        setFormData({ ...formData, [name]: e.target.checked });
      } else {
        setFormData({ ...formData, [name]: value });
      }
    }

    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    
  };

  // Validate the form fields
  const validateForm = () => {
    const newErrors = { ...initialErrorData };
    let isValid = true;

    Object.keys(newErrors).forEach((key) => {
      if (!formData[key] || formData[key].trim() === "") {
        newErrors[key] = `Please enter ${key}`;
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

 

  const transformData = (data) => {
    return {
      personal: {
        title: data.title || "",
        firstname: data.firstname || "",
        middlename: data.fatherHusbandName || "",
        lastname: data.lastname || "",

        dob: data.dob || "",
        birthPlace: data.birthPlace || "",
        nativePlace: data.nativePlace || "",

        nationality: data.nationality || "",
        motherTongue: data.motherTongue || "",
        gender: data.gender || "",
        bloodgroup: data.bloodGroup || "",
        maritalStatus: data.maritalStatus || "",
        disabilityCheck: data.disabilityCheck ? true : false,
        floatingTextarea: data.floatingTextarea || "",
      },
    };
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const formattedData = transformData(formData);
      console.log("Transformed Data:", formattedData);

      detailsSet(formData);
      setCount(count + 1);
      completeCurrentStep(count);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mt-5 p-4 border main rounded-4  bg-white text-start">
        <div className="row  ">
          <div className="col-lg-2">
            <label className="tittle-text" htmlFor="name">
              Title
            </label>
            <select
              className="form-select mt-2"
              name="title"
              value={formData?.title || ""}
              onChange={handleInputChange}
            >
              <option value="">Select Title</option>
              {/* Map through details.title */}
              {initialData?.title?.map((title, index) => (
                <option key={index} value={title}>
                  {title}
                </option>
              )) || <option>Loading...</option>}
            </select>
          </div>

          <div className="col-lg-3 ">
            <label className="tittle-text " htmlFor="name">
              {" "}
              * First Name
            </label>
            <input
              type="text"
              id="firstname"
              name="firstname"
              value={formData?.firstname || ""}
              onChange={handleInputChange}
              placeholder="Enter First Name"
              className={`form-control mt-2`}
            />
            {errors?.firstname && (
              <span className="text-danger fw-medium  d-inline-flex">
                {errors?.firstname}
              </span>
            )}
          </div>
          <div className="col-lg-3">
            <label className="tittle-text" htmlFor="name">
              Father/Husband Name
            </label>
            <input
              type="text"
              placeholder="Enter Father/Husband Name"
              className="form-control mt-2 "
              name="fatherHusbandName"
              value={formData?.fatherHusbandName || ""}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-lg-3">
            <label className="tittle-text" htmlFor="name">
              * Last Name
            </label>
            <input
              type="text"
              id="lastname"
              name="lastname"
              value={formData?.lastname || ""}
              onChange={handleInputChange}
              className={`form-control mt-2`}
              placeholder=" Enter Last name"
            />
            {errors?.lastname && (
              <span className="text-danger fw-medium  d-inline-flex">
                {errors?.lastname}
              </span>
            )}
          </div>

          {/* second row  */}
          <div className="col-lg-2 mt-3 ">
            <label className="tittle-text" htmlFor="dob ">
              * Date of Birth
            </label>
            <input
              type="date"
              id="dob"
              name="dob"
              className="form-control  mt-2"
              placeholder="Select Date"
              value={formData?.dob || ""}
              onChange={handleInputChange}
            />
            {errors?.dob && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.dob}
              </span>
            )}
          </div>

          <div className="col-lg-2 mt-3">
            <label className="tittle-text" htmlFor="name">
              Place of Birth
            </label>
            <input
              type="text"
              id="birthPlace"
              name="birthPlace"
              placeholder="Enter Place of Birth"
              className="form-control  mt-2"
              value={formData?.birthPlace || ""}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-lg-2 mt-3">
            <label className="tittle-text" htmlFor="name mt-2">
              Native Place
            </label>
            <input
              type="text"
              id="nativePlace"
              name="nativePlace"
              placeholder="Enter Native Place"
              className="form-control  mt-2"
              value={formData?.nativePlace || ""}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-lg-2 mt-3">
            <label className="tittle-text" htmlFor="name mt-3">
              Nationality
            </label>
            <select
              className="form-select mt-2"
              aria-label="Default select example  "
              name="nationality"
              value={formData?.nationality || ""}
              onChange={handleInputChange}
            >
              <option defaultValue="india">Select</option>
              <option value="india">India</option>
              <option value="america">America</option>
              <option value="nepal">Nepal</option>
            </select>
          </div>

          <div className="col-lg-3 mt-3">
            <label className="tittle-text" htmlFor="name">
              Mother Tongue
            </label>
            <select
              className="form-select mt-2"
              aria-label="Default select example "
              name="motherTongue"
              value={formData?.motherTongue || ""}
              onChange={handleInputChange}
            >
              <option defaultValue="hindi">Select</option>
              <option value="hindi">Hindi</option>
              <option value="gujarati">Gujarati</option>
              <option value="english">English</option>
            </select>
          </div>

          {/* genders  */}
          <div className="col-11 mt-3">
            <label className="tittle-text">* Gender</label>
            <div className="d-flex gap-3 flex-wrap mt-2">
              {["Male", "Female", "Other"].map((gender, index) => (
                <React.Fragment key={index}>
                  <input
                    hidden
                    // key={index}
                    name="gender"
                    id={`gender-${index}`}
                    type="radio"
                    value={gender}
                    onChange={handleInputChange}
                  />
                  <label
                    htmlFor={`gender-${index}`}
                    className={`btn rounded-5 button1 ${
                      formData?.gender === gender ? "active" : ""
                    }`}
                  >
                    {gender}
                  </label>
                </React.Fragment>
              ))}
            </div>
            {errors?.gender && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.gender}
              </span>
            )}
          </div>

          {/* blood group */}
          <div className="col-11 mt-3">
            <label className="tittle-text">* Blood Group</label>
            <div className="d-flex gap-3 flex-wrap mt-2">
              {initialData?.bloodgroup?.map((group, index) => (
                <React.Fragment key={index}>
                  <input
                    // key={index}
                    hidden
                    type="radio"
                    name="bloodGroup"
                    value={group}
                    id={`bloodGroup-${index}`}
                    onChange={handleInputChange}
                  />
                  <label
                    htmlFor={`bloodGroup-${index}`}
                    className={`btn rounded-5 button1 ${
                      formData?.bloodGroup === group ? "active" : ""
                    }`}
                  >
                    {group}
                  </label>
                </React.Fragment>
              ))}
            </div>
            {errors?.bloodGroup && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.bloodGroup}
              </span>
            )}
          </div>

          {/* Status  */}
          <div className="col-11 mt-3">
            <label className="tittle-text">* Marital Status</label>
            <div className="d-flex gap-3 flex-wrap mt-2">
              {["Single", "Married", "Other"].map((status, index) => (
                <React.Fragment key={index}>
                  <input
                    // key={index}
                    hidden
                    type="radio"
                    name="maritalStatus"
                    value={status}
                    id={`maritalStatus-${index}`}
                    onChange={handleInputChange}
                  />
                  <label
                    htmlFor={`maritalStatus-${index}`}
                    className={`btn rounded-5 button1 ${
                      formData?.maritalStatus === status ? "active" : ""
                    }`}
                  >
                    {status}
                  </label>
                </React.Fragment>
              ))}
            </div>
            {errors?.maritalStatus && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.maritalStatus}
              </span>
            )}
          </div>

          {/* Disability  */}
          <div className="col-11 mt-4 ">
            <div className="d-flex align-items-center">
              <input
                type="checkbox"
                className="form-check-input"
                id="disabilityCheck"
                name="disabilityCheck"
                checked={formData?.disabilityCheck ? true : false}
                onChange={handleInputChange}
              />
              <label className="mx-2   tittle-text" htmlFor="disabilityCheck">
                Any Disability?
              </label>
            </div>

            {
              formData?.disabilityCheck &&
            <div className="col-12 mt-3">
              <label className="tittle-text" htmlFor="">
                Disability Info
              </label>
              <div></div>
              <div className="form-floating col-12 mt-2">
                <textarea
                  className="form-control"
                  placeholder="Leave a comment here"
                  id="floatingTextarea"
                  name="floatingTextarea"
                  value={formData?.floatingTextarea || ""}
                  onChange={handleInputChange}
                ></textarea>
              </div>
            </div>
            }
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end gap-3 mt-3">
        {count !== 0 && (
          <button
            className="rounded-5 btnBlue"
            onClick={() => setCount(count - 1)}
          >
            Previous
          </button>
        )}
        {count < 5 && (
          <button type="submit" className="rounded-5 btnBlue btn">
            Next
          </button>
        )}
      </div>
    </form>
  );
};

export default Steps1;

// import React, { useState } from "react";

// const Steps1 = ({ count, setCount, detailsSet, details }) => {
//   const [gender, setGender] = useState("");
//   const [bloodGroup, setBloodGroup] = useState("");

//   const [status, setStatus] = useState("");

//   const [formData, setFormData] = useState({
//     title: "",
//     firstname: "",
//     fatherHusbandName: "",
//     lastname: "",
//     dob: "",
//     birthPlace: "",
//     nativePlace: "",
//     nationality: "",
//     motherTongue: "",
//     gender: "",
//     bloodGroup: "",
//     maritalStatus: "",
//     checkDisability: "",
//     disability: "",
//   });

//   const [errors, setErrors] = useState({
//     firstname: "",
//     lastname: "",
//     dob: "",
//     gender: "",
//     bloodGroup: "",
//     maritalStatus: "",
//   });

// const handleValidation = () => {
//   const newErrors = {};
//   // if (!details?.firstname) newErrors.firstname = "First Name is required.";

//   // if (!details?.lastname) newErrors.lastname = "Last Name is required.";

//   // if (!details?.dob) newErrors.dob = "Date of Birth is required.";

//   // if (!details?.gender) newErrors.gender = "Gender is required.";

//   // if (!details?.bloodGroup) newErrors.bloodGroup = "Blood Group is required.";

//   // if (!details?.maritalStatus)
//   //   newErrors.maritalStatus = "Marital Status is required.";

//   setErrors(newErrors);
//   return Object.keys(newErrors).length === 0; // Return true if no errors
// };

//   const handleNext = () => {
//     // console.log(handleValidation());
//     // console.log(errors);

//     if (handleValidation()) {
//       setCount(count + 1);
//     }
//   };
//   // Handle form input changes
//   const handleChange = (field, value) => {
//     setFormData({ ...formData, [field]: value });
//     setErrors({ ...errors, [field]: "" }); // Clear error when user types
//   };

//   return (
//     <div>
//       {/* <div className="stepProgrees text-start mt-2">
//         <p className="d-flex tittle-text mb-0">
//           <b style={{ color: "#034DA2" }} className="">
//             Personal
//           </b>
//         </p>
//         <p style={{ color: "#034DA2" }} className="tittle-text mb-0">
//           Basic Details
//         </p>
//       </div> */}
//       <div className="mt-5 p-4 border main rounded-4  bg-white">
//         <div className="row  ">
//           <div className="col-md-2 ">
//             <label className="tittle-text" htmlFor="name">
//               Title
//             </label>
//             <select
//               className="form-select mt-2"
//               aria-label="Default select  example"
//               name="title"

//             >
//               <option  defaultValue="mr">
//                 {" "}
//                 Mr.{" "}
//               </option>
//               <option value="mrs">Mrs.</option>
//               <option value="ms">Ms.</option>
//             </select>
//           </div>
//           <div className="col-md-3 ">
//             <label className="tittle-text" htmlFor="name">
//               {" "}
//               * First Name
//             </label>
//             <input
//               type="text"
//               id="firstname"
//               placeholder="Enter First Name"
//               className={`form-control mt-2 ${
//                  errors.firstname ? "is-invalid" : ""
//               }`}
//               name="firstname"

//               value={formData.firstname}
//               onChange={(e) => handleChange("firstname", e.target.value)}
//             />
//             {!details?.firstname && errors.firstname && (
//               <div className="text-danger fw-medium">{errors.firstname}</div>
//             )}
//           </div>
//           <div className="col-md-3">
//             <label className="tittle-text" htmlFor="name">
//               Father/Husband Name
//             </label>
//             <input
//               type="text"
//               placeholder="Enter Father/Husband Name"
//               className="form-control mt-2 "
//               name="father_husband_name"
//               value={details?.father_husband_name}
//               onChange={detailsSet}
//             />
//           </div>
//           <div className="col-md-3">
//             <label className="tittle-text" htmlFor="name">
//               * Last Name
//             </label>
//             <input
//               type="text"
//               id="lastname"
//               className={`form-control mt-2 ${
//                 !details?.lastname && errors.lastname ? "is-invalid" : ""
//               }`}
//               name="lastname"
//               value={details?.lastname}
//               onChange={detailsSet}
//               // value={formData.lastname}
//               // onChange={(e) => handleChange("lastname", e.target.value)}
//               placeholder=" Enter Last name"
//             />
//             {!details?.lastname && errors.lastname && (
//               <div className="text-danger fw-medium">{errors.lastname}</div>
//             )}
//           </div>
//           {/* second row  */}
//           <div className="col-md-2 mt-3 ">
//             <label className="tittle-text" htmlFor="dob ">
//               * Date of Birth
//             </label>
//             <input
//               type="date"
//               id="dob"
//               name="dob"
//               placeholder="Select Date"
//               className={`form-control mt-2 ${
//                 !details?.dob && errors.dob ? "is-invalid" : ""
//               }`}
//               // value={formData.dob}
//               // onChange={(e) => handleChange("dob", e.target.value)}
//               value={details?.dob}
//               onChange={detailsSet}
//             />
//             {!details?.dob && errors.dob && (
//               <div className="text-danger fw-medium">{errors.dob}</div>
//             )}
//           </div>
//           <div className="col-md-2 mt-3">
//             <label className="tittle-text" htmlFor="name">
//               Place of Birth
//             </label>
//             <input
//               type="text"
//               id="birthPlace"
//               placeholder="Enter Place of Birth"
//               className="form-control  mt-2"
//               value={details?.birthPlace}
//               onChange={detailsSet}
//             />
//           </div>
//           <div className="col-md-2 mt-3">
//             <label className="tittle-text" htmlFor="name mt-2">
//               Native Place
//             </label>
//             <input
//               type="text"
//               id="nativePlace"
//               placeholder="Enter Native Place"
//               className="form-control  mt-2"
//               value={details?.nativePlace}
//               onChange={detailsSet}
//             />
//           </div>
//           <div className="col-md-2 mt-3">
//             <label className="tittle-text" htmlFor="name mt-3">
//               Nationality
//             </label>
//             <select
//               className="form-select mt-2"
//               aria-label="Default select example  "
//               name="nationality"
//               value={details?.nationality}
//               onChange={detailsSet}
//             >
//               <option  defaultValue="india" >
//                 Select
//               </option>
//               <option value="india">India</option>
//               <option value="america">America</option>
//               <option value="nepal">Nepal</option>
//             </select>
//           </div>
//           <div className="col-md-3 mt-3">
//             <label className="tittle-text" htmlFor="name">
//               Mother Tongue
//             </label>
//             <select
//               className="form-select mt-2"
//               aria-label="Default select example "
//               name="motherTongue"
//               value={details?.motherTongue}
//               onChange={detailsSet}
//             >
//               <option  defaultValue="hindi" >
//                 Select
//               </option>
//               <option value="hindi">Hindi</option>
//               <option value="gujarati">Gujarati</option>
//               <option value="english">English</option>
//             </select>
//           </div>{" "}
//           {/* genders  */}
//           {/* <div className="col-11 mt-3 ">
//             <div className="">
//               <label className="tittle-text">* Gender</label>
//               <div className="d-flex gap-3 flex-wrap mt-2">
//                 <button
//                   className={`btn rounded-5 button1 ${
//                     gender === "Male" ? "active " : ""
//                   } `}
//                   onClick={() => setGender("Male")}
//                 >
//                   Male
//                 </button>
//                 <button
//                   className={`btn rounded-5 button1 ${
//                     gender === "Female" ? "active " : ""
//                   } `}
//                   onClick={() => setGender("Female")}
//                 >
//                   Female
//                 </button>
//                 <button
//                   className={`btn rounded-5 button1 ${
//                     gender === "Other" ? "active " : ""
//                   } `}
//                   onClick={() => setGender("Other")}
//                 >
//                   Other
//                 </button>
//               </div>
//             </div>
//           </div> */}
//           <div className="col-11 mt-3">
//             <label className="tittle-text">* Gender</label>
//             <div className="d-flex gap-3 flex-wrap mt-2">
//               {["Male", "Female", "Other"].map((gender) => (
//                 <button
//                   name="gender"
//                   value={gender}
//                   key={gender}
//                   className={`btn rounded-5 button1 ${
//                     formData.gender === gender ? "active" : ""
//                   }`}
//                   onClick={() => handleChange("gender", gender) && detailsSet}
//                   // onClick={(e) => console.log(e.target)}
//                 >
//                   {gender}
//                 </button>
//               ))}
//             </div>
//             {!details?.gender && errors.gender && (
//               <div className="text-danger fw-medium">{errors.gender}</div>
//             )}
//           </div>
//           {/* blood group */}
//           {/* <div className="col-11 mt-3">
//             <div className="row">
//               <label className="tittle-text"> * Blood Group</label>

//               <div className="d-flex gap-3 flex-wrap mt-2">
//                 <button
//                   className={`btn rounded-5 button1 ${
//                     bloodGroup === "A+" ? "active " : ""
//                   } `}
//                   onClick={() => setBloodGroup("A+")}
//                 >
//                   A+
//                 </button>

//                 <button
//                   className={`btn rounded-5 button1 ${
//                     bloodGroup === "A-" ? "active " : ""
//                   } `}
//                   onClick={() => setBloodGroup("A-")}
//                 >
//                   A-
//                 </button>
//                 <button
//                   className={`btn rounded-5 button1 ${
//                     bloodGroup === "B+" ? "active " : ""
//                   } `}
//                   onClick={() => setBloodGroup("B+")}
//                 >
//                   B+
//                 </button>
//                 <button
//                   className={`btn rounded-5 button1 ${
//                     bloodGroup === "B-" ? "active " : ""
//                   } `}
//                   onClick={() => setBloodGroup("B-")}
//                 >
//                   B-
//                 </button>
//                 <button
//                   className={`btn rounded-5 button1 ${
//                     bloodGroup === "AB+" ? "active " : ""
//                   } `}
//                   onClick={() => setBloodGroup("AB+")}
//                 >
//                   AB+
//                 </button>
//                 <button
//                   className={`btn rounded-5 button1 ${
//                     bloodGroup === "AB-" ? "active " : ""
//                   } `}
//                   onClick={() => setBloodGroup("AB-")}
//                 >
//                   AB-
//                 </button>
//                 <button
//                   className={`btn rounded-5 button1 ${
//                     bloodGroup === "O+" ? "active " : ""
//                   } `}
//                   onClick={() => setBloodGroup("O+")}
//                 >
//                   O+
//                 </button>
//                 <button
//                   className={`btn rounded-5 button1 ${
//                     bloodGroup === "O-" ? "active " : ""
//                   } `}
//                   onClick={() => setBloodGroup("O-")}
//                 >
//                   O-
//                 </button>
//               </div>
//             </div>
//           </div> */}
//           <div className="col-11 mt-3">
//             <label className="tittle-text">* Blood Group</label>
//             <div className="d-flex gap-3 flex-wrap mt-2">
//               {["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].map(
//                 (group) => (
//                   <button
//                     key={group}
//                     className={`btn rounded-5 button1 ${
//                       formData.bloodGroup === group ? "active" : ""
//                     }`}
//                     onClick={() => handleChange("bloodGroup", group)}
//                   >
//                     {group}
//                   </button>
//                 )
//               )}
//             </div>
//             {errors.bloodGroup && (
//               <div className="text-danger fw-medium">{errors.bloodGroup}</div>
//             )}
//           </div>
//           {/* Status  */}
//           {/* <div className="col-11 mt-3">
//             <label className="form-label tittle-text fw-semibold">
//               {" "}
//               *Marital Status
//             </label>
//             <div className="d-flex gap-3 flex-wrap ">
//               <button
//                 className={`btn rounded-5 button1 ${
//                   status === "Single" ? "active " : ""
//                 } `}
//                 onClick={() => setStatus("Single")}
//               >
//                 Single
//               </button>
//               <button
//                 className={`btn rounded-5 button1 ${
//                   status === "Married" ? "active " : ""
//                 } `}
//                 onClick={() => setStatus("Married")}
//               >
//                 Married
//               </button>
//               <button
//                 className={`btn rounded-5 button1 ${
//                   status === "Separated" ? "active " : ""
//                 } `}
//                 onClick={() => setStatus("Separated")}
//               >
//                 Separated
//               </button>
//               <button
//                 className={`btn rounded-5 button1 ${
//                   status === "Divorcee" ? "active " : ""
//                 } `}
//                 onClick={() => setStatus("Divorcee")}
//               >
//                 Divorcee
//               </button>
//               <button
//                 className={`btn rounded-5 button1 ${
//                   status === "Widow" ? "active " : ""
//                 } `}
//                 onClick={() => setStatus("Widow")}
//               >
//                 Widow
//               </button>
//               <button
//                 className={`btn rounded-5 button1 ${
//                   status === "Widower" ? "active " : ""
//                 } `}
//                 onClick={() => setStatus("Widower")}
//               >
//                 Widower
//               </button>
//             </div>
//           </div> */}
//           <div className="col-11 mt-3">
//             <label className="tittle-text">* Marital Status</label>
//             <div className="d-flex gap-3 flex-wrap mt-2">
//               {["Single", "Married", "Other"].map((status) => (
//                 <button
//                   key={status}
//                   className={`btn rounded-5 button1 ${
//                     formData.maritalStatus === status ? "active" : ""
//                   }`}
//                   onClick={() => handleChange("maritalStatus", status)}
//                 >
//                   {status}
//                 </button>
//               ))}
//             </div>
//             {errors.maritalStatus && (
//               <div className="text-danger fw-medium">
//                 {errors.maritalStatus}
//               </div>
//             )}
//           </div>
//           {/* Disability  */}
//           <div className="col-11 mt-4 ">
//             <div className="d-flex align-items-center">
//               <input
//                 type="checkbox"
//                 className="form-check-input"
//                 id="disabilityCheck"
//               />
//               <label className="mx-2   tittle-text" htmlFor="disabilityCheck">
//                 Any Disability?
//               </label>
//             </div>

//             <div className="col-12 mt-3">
//               <label className="tittle-text" htmlFor="">
//                 Disability Info
//               </label>
//               <div></div>
//               <div className="form-floating col-12 mt-2">
//                 <textarea
//                   className="form-control"
//                   placeholder="Leave a comment here"
//                   id="floatingTextarea"
//                 ></textarea>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="d-flex justify-content-end gap-3 mt-3">
//         {count !== 0 && (
//           <button
//             className="rounded-5 btnBlue"
//             onClick={() => setCount(count - 1)}
//           >
//             Previous
//           </button>
//         )}
//         {count < 5 && (
//           <button
//             className="rounded-5 btnBlue  "
//             // onClick={() => setCount(count + 1)}
//             onClick={handleNext}
//           >
//             Next
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Steps1;
